export default __webpack_public_path__ + "static/media/tiktokDeskMobile.d7d4075e.svg";